// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"107":"1085865f","926":"b921d152"}[chunkId] + ".chunk.css";
};